import moment from 'moment';
export default {
    FormatDateTime: function (date) {
        return moment(date).format('DD/MM/YYYY HH:mm');
    },

    FormatDate: function (date) {
        return moment(date).format('DD/MM/YYYY');
    },


    // FormatPrice: function (price) {
    //     let price_ = price.toFixed(decimals).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(',');

    //     console.log(decimals)

    //     if (price_.length === 1) {
    //         price_[1] = "00";
    //     } else if (price_[1].length === 1) {
    //         price_[1] = price_[1] + "0";
    //     }
    //     return price_.join(',');
    // }

    /*
        Este tipo de formatPrice es para el apartado de CC,
        en la que se necesita por cuestiones de impuestos y
        chequeos de deudas los centavos de los importes.
    */

    FormatPriceCC: function (price) {
        price = parseFloat(price).toFixed(2);  // Asegurarse de que siempre tenga dos decimales
        let [integerPart, decimalPart] = price.toString().split('.');
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${integerPart},${decimalPart}`;
    },

    FormatPrice: function (price) {
        let priceString = price.toString();
        const decimalIndex = priceString.indexOf('.') !== -1 ? priceString.indexOf('.') : priceString.indexOf(',');

        if (decimalIndex !== -1) {
            priceString = priceString.substring(0, decimalIndex);
        }

        const parts = [];
        for (let i = priceString.length - 1, j = 1; i >= 0; i--, j++) {
            parts.unshift(priceString[i]);
            if (j % 3 === 0 && i !== 0) parts.unshift('.');
        }
        return parts.join('');
    }


}



// WEBPACK FOOTER //
// ./src/functions/functions.js